import React from "react";
import { BackgroundSVG } from "./BackgroundSVG";

function BackgroundCircle1() {
  return (
    <BackgroundSVG
      top={"0"}
      right={"0"}
      left={"0"}
      width="130"
      height="65"
      viewBox="0 0 130 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.479 0.000190735C129.48 0.18663 129.481 0.373604 129.481 0.560402C129.481 36.1496 100.612 65 64.9998 65C29.3879 65 0.518982 36.1496 0.518982 0.560402C0.518982 0.373589 0.519806 0.18663 0.521393 0.000190735L129.479 0.000190735Z"
        fill="#825EEE"
      />
    </BackgroundSVG>
  );
}

export default BackgroundCircle1;
